<a
    [routerLink]="[link, params]"
    routerLinkActive="c-menu-entry__link--active"
    class="c-menu-entry__link"
    [attr.data-id]="dataId"
>
    <svg><use [attr.xlink:href]="'images/menu/all.svg#' + icon"></use></svg>
    <span class="c-menu-entry__link-label">{{label}}</span>
</a>
